import { render, staticRenderFns } from "./orderCardList.vue?vue&type=template&id=41d93838&scoped=true&"
import script from "./orderCardList.vue?vue&type=script&lang=js&"
export * from "./orderCardList.vue?vue&type=script&lang=js&"
import style0 from "./orderCardList.vue?vue&type=style&index=0&id=41d93838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d93838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d93838')) {
      api.createRecord('41d93838', component.options)
    } else {
      api.reload('41d93838', component.options)
    }
    module.hot.accept("./orderCardList.vue?vue&type=template&id=41d93838&scoped=true&", function () {
      api.rerender('41d93838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shop/orderList/orderCardList.vue"
export default component.exports